import { useQuery } from "react-query";
import { axiosClient } from "@/services/utilities";

export interface ApiListParams {
  search?: string;
  page?: number;
  limit?: number;
  publisherUsername?: string;
  category?: string;
  typePlan?: string;
  status?: string;
}

const fetchApiList = async (params: ApiListParams) => {
  const res = await axiosClient.get("/apis/list", {
    params: {
      search: params.search || "",
      page: params.page || 1,
      limit: params.limit || 10,
      publisherUsername: params.publisherUsername || "",
      category: params.category || "",
      typePlan: params.typePlan || "",
      status: params.status || "",
    },
  });

  const raw = res.data;

  return {
    items: raw.items ?? [],
    total: Number(raw.total ?? 0),
    page: Number(raw.page ?? 1),
    limit: Number(raw.limit ?? 10),
    totalPages: Number(raw.totalPages ?? 1),
  };
};

export const useApiListQuery = (params: ApiListParams) => {
  return useQuery(
    [
      "apiList",
      params.search,
      params.page,
      params.limit,
      params.publisherUsername,
      params.category,
      params.typePlan,
      params.status,
    ],
    () => fetchApiList(params),
    {
      keepPreviousData: true,
      staleTime: 5000,
    }
  );
};
